import { useNavigate, useParams, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@shared/hooks';
import { ssManager } from '@shared/utils';
import * as Sentry from '@sentry/react';
import { Routes } from '@shared/enums';
import { useEffect, FC } from 'react';

import { CompanyLayout } from './company-layout';

export const CompanyRoute: FC = () => {
  const { user } = useCurrentUser();
  const { companyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    /* at this point user is already logged in */
    /* if user is not assigned to company or company id is not present, redirect to root */
    /* it should never happen, but just in case */
    const companyExists = user.companies?.some((company) => company.id === companyId);
    if (!companyId || !companyExists) {
      Sentry.captureException(new Error(`Company ${companyId} not found`), {
        extra: { companyId, route: window.location.pathname },
        level: 'error',
      });

      ssManager.remove('COMPANY_ID');
      navigate(Routes.NOT_FOUND);
    }
  }, [companyId, user, navigate]);

  return (
    <CompanyLayout>
      <Outlet />
    </CompanyLayout>
  );
};
